var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDisclaimer)?_c('div',{staticClass:"modal-backdrop",class:{mobile: _vm.isMobile}},[_c('iframe',{staticStyle:{"min-width":"100%","min-height":"100%"},attrs:{"src":_vm.legalUrl}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }